module.exports = "/assets/novos3-temperature-sensor-configuration-left.png";